import axios from "axios";
import { put, all } from "redux-saga/effects";
import CryptoJS from "crypto-js";
import { setNotification } from "./modules/notification";

const TOKEN_SESSION_NAME = "requestToken";
export const COOKIE_SESSION_NAME = "showPrivacyCookie";

export const SUCCESS = "SUCCESS";
export const FAILED = "FAILED";

const customHeader = {
  "Content-Type": "application/json",
};

const PASSWORD = "K0xpZ0RpZ0AyMDIwK1BQQQ==";
const cipherOption = {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7,
};

const getBase64Psw = (psw) => {
  let password = PASSWORD;
  if (psw) {
    try {
      atob(psw);
      password = psw;
    } catch (e) {
      if (psw.length !== 16) return { exitCode: FAILED, msg: "ld.tools.passwordCorta" };
      else password = btoa(psw);
    }
  }
  return password;
};

function* apiCreateRequest(method, baseUrl, apiUrl, queryParams, payload, headers) {
  let pathUrl = baseUrl;
  if (apiUrl && apiUrl !== undefined && apiUrl.length > 0) pathUrl += "/" + apiUrl;

  let apiHeaders = customHeader;
  if (headers && headers !== undefined) apiHeaders = { ...apiHeaders, ...headers };
  const token = window.sessionStorage.getItem(TOKEN_SESSION_NAME);
  if (token && token !== undefined) apiHeaders = { ...apiHeaders, Authorization: "Bearer " + token };

  let queryParamsString = null;
  if (queryParams && queryParams !== undefined) {
    queryParamsString = "?";
    for (let [key, value] of Object.entries(queryParams)) {
      queryParamsString += "" + key + "=" + value + "&";
    }
    queryParamsString = queryParamsString.substr(0, queryParamsString.length - 1);
  }

  if (queryParamsString && queryParamsString !== undefined) pathUrl += queryParamsString;

  if (baseUrl) {
    const axiosParams = {
      method: method,
      url: pathUrl,
      headers: apiHeaders,
      ...(payload && { data: payload }),
    };
    return yield axios(axiosParams);
  } else return { status: 400, message: "missing base url parameter" };
}

export function* dispatchResponseNotification(response) {
  const notificationList = response.data.lstResponseMessage;
  if (notificationList && notificationList !== undefined && notificationList.length > 0)
    yield all(
      notificationList.map((notification) =>
        put(setNotification(notification.tipoMessaggio, notification.messaggio, notification.descrizione))
      )
    );
}

export function* createRequest(method, baseUrl, apiUrl, queryParams, payload, headers) {
  try {
    const response = yield apiCreateRequest(method, baseUrl, apiUrl, queryParams, payload, headers);
    yield dispatchResponseNotification(response);
    return response;
  } catch (e) {
    yield dispatchResponseNotification(e.response);
    throw e
  }
}

export const salvaInfoSuSessionStorage = (redirectUrl, commonStore) => {
  sessionStorage.setItem("redirectUrl", redirectUrl);
  if (!localStorage.getItem("staticInfo")) localStorage.setItem("staticInfo", JSON.stringify(commonStore));
};

export const addSessionStorage = (token) => {
  if (token) window.sessionStorage.setItem(TOKEN_SESSION_NAME, token);
};

export const removeSessionStorage = () => {
  if (window.sessionStorage.getItem(TOKEN_SESSION_NAME) !== undefined)
    window.sessionStorage.removeItem(TOKEN_SESSION_NAME);
  if (window.sessionStorage.getItem(COOKIE_SESSION_NAME) !== undefined)
    window.sessionStorage.removeItem(COOKIE_SESSION_NAME);
};

// eslint-disable-next-line
export const mobileAndTabletCheck = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      // eslint-disable-next-line
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const getMessageString = (intl, text) => intl.formatMessage({ id: text, defaultMessage: text });

export const encrypt = (obj, psw = null) => {
  let password = getBase64Psw(psw);
  if (password.msg) return password;
  const encryptedPassword = CryptoJS.enc.Base64.parse(password);
  try {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(obj), encryptedPassword, cipherOption)
      .toString()
      .replaceAll("/", "slash");
    return { exitCode: SUCCESS, value: encrypted };
  } catch (e) {
    return { exitCode: FAILED, msg: "ldCore.tools.erroreCriptazione" };
  }
};

export const decrypt = (obj, psw = null) => {
  let password = getBase64Psw(psw);
  if (password.msg) return password;
  const encryptedPassword = CryptoJS.enc.Base64.parse(password);
  try {
    const decrypted = JSON.parse(
      CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(obj.replaceAll("slash", "/"), encryptedPassword, cipherOption))
    );
    return { exitCode: SUCCESS, value: decrypted };
  } catch (e) {
    return { exitCode: FAILED, msg: "ldCore.tools.passwordDiverse" };
  }
};
